import { useDispatch, useSelector } from 'react-redux';
import type { TypedUseSelectorHook } from 'react-redux';
import { AppDispatch, RootState } from '../store/store';
import { useState, useCallback } from 'react';

export const useAppDispatch: () => AppDispatch = useDispatch;
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;

export function useError() {
    const [error, setError] = useState<Error | null>(null);

    const handleError = useCallback((error: Error) => {
        setError(error);
    }, []);

    return { error, handleError };
}
